module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_6005.3f3a3592.png";